/** @jsxImportSource theme-ui @jsxRuntime classic */
import * as Icons from '@tishman/icons';
import React from 'react';

import { Text, Flex, Link, Box } from '..';

export interface FooterFollowUsProps {
  facebook: string;
  instagram: string;
  twitter: string;
}

const iconStyles = {
  'display': 'inline-block',
  'width': [50, 72],
  'color': 'text',
  ':hover': {
    color: 'primary',
  },
};

export const FooterFollowUs = ({
  facebook,
  twitter,
  instagram,
}: FooterFollowUsProps): React.JSX.Element => (
  <Flex sx={{ flexDirection: 'column', justifyContent: 'space-between' }}>
    <Text as="h2" variant="footerFirstSectionHeading">
      Follow Us
    </Text>
    <Flex as="ul">
      <Box as="li">
        <Link
          aria-label="Follow us on Facebook"
          href={facebook}
          sx={iconStyles}
          target="_blank"
        >
          <Icons.Fb aria-hidden="true" height="100%" width="100%" />
        </Link>
      </Box>
      <li>
        <Link
          aria-label="Follow us on X"
          href={twitter}
          sx={{ ...iconStyles, mx: 3 }}
          target="_blank"
        >
          <Icons.X aria-hidden="true" height="100%" width="100%" />
        </Link>
      </li>
      <li>
        <Link
          aria-label="Follow us on Instagram"
          href={instagram}
          sx={iconStyles}
          target="_blank"
        >
          <Icons.Ig aria-hidden="true" height="100%" width="100%" />
        </Link>
      </li>
    </Flex>
  </Flex>
);
